<!--
 * @Date: 2021-05-15 13:06:55
-->
<template>
  <div class="privacyPolicy-wrap" @scroll.passive="getScroll($event)">
    <div class="content-wrap" ref="pronbit">
      <div class="left-wrap" :class="Active">
        <span v-for="(item,index) in leftList" :key="index" @click="navMneu(index)">{{item}}</span>
        <div class="pic"></div>
      </div>
   <div class="right-wrap">
     <div class="page1-wrap same" v-if="curIndex == 0">
       <div class="list-wrap">
         <ul class="item-wrap" v-for="(item,index) in textList" :key="index">
           <p class="title-Big " v-html="$t('duthOne.' + item.tibleItem)"></p>
           <li class="item-two-wrap" v-for="(item2,index2) in item.textChild" :key="index2">
             <span class="title-a" v-if="item2.twoItem">{{$t('duthOne.' + item2.twoItem)}}</span>
             <ol class="title-b" v-for="(item3,index3) in item2.TwoChild" :key="index3">
               <span class="title-c" v-html="$t('duthOne.' + item3)"></span>
             </ol>
           </li>
         </ul>
       </div>
     </div>
    <!-- 第二页 -->
     <div class="page1-wrap same" v-if="curIndex == 1">
       <div class="list-wrap">
         <ul class="item-wrap" v-for="(item,index) in textList2" :key="index">
           <p class="title-Big " v-html="$t('duthTwo.' + item.tibleItem)"></p>
           <li class="item-two-wrap" v-for="(item2,index2) in item.textChild" :key="index2">
             <span class="title-a" v-if="item2.twoItem">{{$t('duthTwo.' + item2.twoItem)}}</span>
             <ol class="title-b" v-for="(item3,index3) in item2.TwoChild" :key="index3">
               <span class="title-c" v-html="$t('duthTwo.' + item3)"></span>
             </ol>
           </li>
         </ul>
       </div>
     </div>
    <!-- 第三页 -->
     <div class="page3-wrap same" v-if="curIndex == 2">
       <div class="list-wrap">
         <ul class="item-wrap" v-for="(item,index) in textList3" :key="index" :class="'item-wrap-' + index">
           <p class="title-Big " v-html="$t('duthThree.' + item.tibleItem)"></p>
           <li class="item-two-wrap" v-for="(item2,index2) in item.textChild" :key="index2" :class="'item-two-'+ index2">
             <span class="title-a" v-if="item2.twoItem">{{$t('duthThree.' + item2.twoItem)}}</span>
             <ol class="title-b" v-for="(item3,index3) in item2.TwoChild" :key="index3" :class="'item-c'+ index3">
               <span class="title-c" v-html="$t('duthThree.' + item3)"></span>
             </ol>
           </li>
         </ul>
       </div>
     </div>
      <div class="bottom-wrap">
        <span>{{$t('dutyFooter.item1')}}</span>
        <span>{{$t('dutyFooter.item2')}}</span>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name:"privacyPolicy",
  metaInfo() {
    return {
      title: this.getSeoData.title && this.getSeoData.title,
      meta: [
        {
          name: "keyWords",
          content: this.getSeoData.products && this.getSeoData.products.content,
        },
        {
          name: "description",
          content: this.getSeoData.products && this.getSeoData.products.description,
        },
      ],
    };
  },
  data() {
    return {
      scroll:0,
      top:0,
      curIndex:2,
      isBottom:false,
      leftList:[this.$t('dutyFooter.leftLable1'),this.$t('dutyFooter.leftLable2'),this.$t('dutyFooter.leftLable3'),],
      textList:[
        {tibleItem:'page1Title',textChild:[
          {twoItem:'',TwoChild:['page1Text1','page1Text2','page1Text3','page1Text4','page1Text6','page1Text8','page1Text9','page1Text10','page1Text11','page1Text12','page1Text13']}
        ]},
        {tibleItem:'page2Title',textChild:[
          {twoItem:'',TwoChild:['page2Text2']}
        ]},
        {tibleItem:'page2Text3',textChild:[
          {twoItem:'page2Title1',TwoChild:['page1Text14']},
          {twoItem:'page2Title2',TwoChild:['page1Text15']},
          {twoItem:'page2Title3',TwoChild:['page1Text16']},
          {twoItem:'page2Title4',TwoChild:['page1Text17']},
          {twoItem:'page2Title5',TwoChild:['page1Text18']},
          {twoItem:'page2Title6',TwoChild:['page1Text19','page1Text20','page1Text21']},
        ]},
      ],
      textList2:[
        {tibleItem:'page1Title',textChild:[
          {twoItem:'',TwoChild:['page1Text1','page1Text2','page1Text3']}
        ]},
        {tibleItem:'page2Title',textChild:[
          {twoItem:'',TwoChild:['page1Text4','page1Text5','page1Text6','page1Text7','page1Text8','page1Text9','page1Text10','page1Text11','page1Text12']}
        ]},
        {tibleItem:'page3Title',textChild:[
          {twoItem:'',TwoChild:['page1Text13','page1Text14','page1Text15','page1Text16','page1Text17','page1Text18']}
        ]},
        {tibleItem:'page4Title',textChild:[
          {twoItem:'',TwoChild:['page1Text19','page1Text20','page1Text21','page1Text22','page1Text23','page1Text24','page1Text25']}
        ]},
        {tibleItem:'page5Title',textChild:[
          {twoItem:'',TwoChild:['page1Text26','page1Text27','page1Text29','page1Text30']}
        ]},
        {tibleItem:'page6Title',textChild:[
          {twoItem:'',TwoChild:['page1Text31','page1Text32','page1Text33','page1Text34','page1Text35','page1Text36','page1Text37']}
        ]},
        {tibleItem:'page7Title',textChild:[
          {twoItem:'',TwoChild:['page1Text38','page1Text39','page1Text40','page1Text41']}
        ]},
      ],
      textList3:[
        {tibleItem:'page1Title',textChild:[
          {twoItem:'',TwoChild:['page1Text1','page1Text2','page1Text3','page1Text4','page1Text5','page1Text6','page1Text7','page1Text8','page1Text9','page1Text10','page1Text11']}
        ]},
        {tibleItem:'page2Title',textChild:[
          {twoItem:'',TwoChild:['page1Text12','page1Text13','page1Text14']}
        ]},
        {tibleItem:'page3Title',textChild:[
          {twoItem:'',TwoChild:['page1Text15','page1Text16']}
        ]},
        {tibleItem:'page4Title',textChild:[
          {twoItem:'',TwoChild:['page1Text17','page1Text19','page1Text20','page1Text21']}
        ]},
        {tibleItem:'page5Title',textChild:[
          {twoItem:'',TwoChild:['page1Text21a','page1Text22','page1Text23','page1Text24','page1Text26','page1Text27','page1Text28','page1Text29','page1Text30','page1Text31','page1Text32','page1Text33']}
        ]},
        {tibleItem:'page5bTitle',textChild:[
          {twoItem:'',TwoChild:['page1Text22a','page1Text23a','page1Text24a','page1Text25a','page1Text26a','page1Text27a','page1Text28a']}
        ]},
        {tibleItem:'page6Title',textChild:[
          {twoItem:'',TwoChild:['page1Text34','page1Text35','page1Text36','page1Text37']}
        ]},
        {tibleItem:'page7Title',textChild:[
          {twoItem:'',TwoChild:['page1Text38']}
        ]},
        {tibleItem:'page8Title',textChild:[
          {twoItem:'',TwoChild:['page1Text39','page1Text40']}
        ]},
        {tibleItem:'page9Title',textChild:[
          {twoItem:'',TwoChild:['page1Text41']}
        ]},
        {tibleItem:'page10Title',textChild:[
          {twoItem:'',TwoChild:['page1Text42','page1Text43','page1Text44','page1Text45','page1Text46','page1Text47','page1Text48','page1Text49','page1Text50']}
        ]},
        {tibleItem:'page11Title',textChild:[
          {twoItem:'page11Titl1',TwoChild:['page1Text51']},
          {twoItem:'page11Titl2',TwoChild:['page1Text52']},
          {twoItem:'page11Titl3',TwoChild:['page1Text53']},
          {twoItem:'page11Titl4',TwoChild:['page1Text54']},
          {twoItem:'page11Titl5',TwoChild:['page1Text55']},
          {twoItem:'page11Titl6',TwoChild:['page1Text56','page1Text57','page1Text58']},
        ]},
      ],
    }
  },
  methods:{
    menu(){
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      this.top = this.$refs.pronbit.getBoundingClientRect().top;
      // console.log('距离顶部高度',this.$refs.pronbit.getBoundingClientRect().top)
    },
    navMneu(index){
      // this.curIndex = index
      // let top = document.documentElement.scrollTop || document.body.scrollTop;
      // const tiemTop = setInterval(() =>{
      //     document.body.scrollTop = document.documentElement.scrollTop = top -= 50
      //     if(top < 0){
      //         clearInterval(tiemTop)
      //     }
      // },10)
      switch (index) {
        case 0:
          this.$router.push({ path: "/TermsOfServices" });
          break;
        case 1:
          this.$router.push({ path: "/privacy-Policy" });
          break;
        case 2:
          this.$router.push({ path: "/ApplicationsTermsOfUse" });
          break;
        default:
          break;
      }

    }
  },
  computed:{
    Active(){
      // let height= this.$refs.element.offsetHeight;  //100
      if(this.top > 67 || this.top == 0){
        return 'top'
      }else if(this.isBottom){
        return 'bottom'
      }else{
        return 'fixed'
      }
    }
  },
  mounted(){
    window.addEventListener('scroll',this.menu)
    window.addEventListener("scroll", () => {
      let {
        scrollTop,
        scrollHeight,
        clientHeight
      } = document.scrollingElement;
      
      // 当前滚动高度 + 视口高度 >= 文档总高度 - (底部高度)
      if (scrollTop + clientHeight >= scrollHeight - 500) {
        // console.log(scrollHeight,'xxxx')
        // console.log("已到达底部");
        this.isBottom = true
      }else{
        this.isBottom = false
      }
  });
  }
};
</script>

<style lang="scss" scoped>
  @import "privacyPolicy.scss";
</style>